<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="carrent-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Najem aut</h1>
      </div>
      <button
        class="action-pill action-pill--primary"
        @click="dialog = true; currentBonusId = null"
      >
        <v-icon size="14">mdi-plus</v-icon>{{ $t('common.add') }}
      </button>
    </div>
    <v-data-table
          :headers="headers"
          :items="bonuses"
          class="elevation-1"
          :loading="loading"
          :search="search"
          :options.sync="options"
          :server-items-length="totalItems"
        >
          <template v-slot:top>
            <div class="table-section-title">
              <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-key-chain</v-icon></div>
              <div class="filter-title">{{ $t('carRent.title') }}</div>
            </div>
            <div>
              <v-text-field
                v-model="search"
                :label="$t('common.search')"
                class="mx-4"
              ></v-text-field>
            </div>
          </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoBonus(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteBonus="{ item }">
            <v-btn class="error" @click="deleteBonus(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
    </v-data-table>
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('carRent.rentalForm') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submitBonus">
            <v-row>
              <!-- Date -->
              <v-col cols="12" md="6">
                <v-menu
                  ref="dateMenu"
                  v-model="menuDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="bonus.date"
                      :label="$t('common.date')"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[validateRequired]"
                    />
                  </template>
                  <v-date-picker
                    v-model="bonus.date"
                    no-title
                    scrollable
                    show-week
                    first-day-of-week="1"
                    locale-first-day-of-year="4"
                    :locale="$i18n.locale"
                    @input="menuDate = false"
                  />
                </v-menu>
              </v-col>

              <!-- Driver -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="bonus.driverId"
                  :items="drivers"
                  :label="$t('common.driver')"
                  outlined
                  required
                  :rules="[validateRequired]"
                  item-text="name"
                  item-value="id"
                />
              </v-col>

              <!-- Status -->
              <v-col cols="12" md="12">
                <v-select
                  v-model="bonus.status"
                  :items="statusOptions"
                  label="Status"
                  outlined
                  required
                  :rules="[validateRequired]"
                />
              </v-col>
              <!-- Return Cost -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="bonus.name"
                  :label="$t('common.description')"
                  outlined
                  required
                  type="text"
                  :rules="[validateRequired]"
                />
              </v-col>
              <!-- Return Cost -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model.number="bonus.price"
                  :label="$t('carRent.amount')"
                  outlined
                  required
                  type="number"
                  :rules="[validateRequired, validatePositiveNumber]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
                  <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" :disabled="!valid" @click="submitBonus">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      menuDate: false,
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      totalItems: 0,
      bonus: {
        date: null,
        name: null,
        type: null,
        driverId: null,
        status: null,
        price: null,
      },
      headers: [
        {
          text: "Data",
          align: "start",
          sortable: false,
          value: "date",
        },
        {
          text: "Kwota",
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: "Kierowca",
          align: "start",
          sortable: false,
          value: "driver",
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status",
        },
        { text: "", value: "details", sortable: false },
        { text: "", value: "deleteBonus", sortable: false },
      ],
      drivers: [],
      statusOptions: [
        { text: "Oczekujący", value: "PENDING" },
        { text: "Wypłata utworzona", value: "PAYOUT_CREATED" },
        { text: "Zapłacony", value: "PAID" },
      ],
      bonuses: [],
    };
  },
  async created() {
    await this.getDriversSelect();
    await this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    validateRequired(value) {
      return !!value || "To pole jest wymagane";
    },
    validatePositiveNumber(value) {
      return value >= 0 || "Wartość musi być dodatnia";
    },
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    async deleteBonus(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "bonuses/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    async infoBonus(id) {
      await this.toggleLoading(true);
      try {
        const bonus = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "bonuses/details/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.bonus = bonus.data.data;
        this.currentBonusId = bonus.data.data.id;
        this.bonus.driverId = bonus.data.data.driver.id;
        delete bonus.data.data.driver;
        this.bonus.date = dayjs(bonus.data.data.date).format("YYYY-MM-DD");
        this.bonus.price = bonus.data.data.price / 100;
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async submitBonus() {
      // Process the bonus data here
      try {
        await this.toggleLoading(true);
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "bonuses",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: {
            ...this.bonus,
            type: 'RENT',
            id: this.currentBonusId || undefined,
          },
        });
        this.closeDialog();
        await this.toggleLoading(false);
        await this.initialize();
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async initialize() {
      this.loading = true;
      if (this.search.trim().length > 0) {
        this.options.page = 1;
      }
      try {
        const bonuses = await axios({
          method: "get",
          url:
            process.env.VUE_APP_ROOT_API +
            `bonuses/all-rent?take=${this.options.itemsPerPage}&skip=${this.options.page}&search=${this.search}`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.bonuses = bonuses.data.data.result.map((bonus) => {
          return {
            price: bonus.price / 100,
            driver: bonus.driver.firstName + " " + bonus.driver.lastName,
            status: bonus.status,
            date: dayjs(bonus.date).format("DD-MM-YYYY"),
            id: bonus.id,
          };
        });
        this.totalItems = bonuses.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async getDriversSelect() {
      await this.toggleLoading(true);
      try {
        const drivers = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `drivers?take=100&skip=1`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.drivers = drivers.data.data.result.map((it) => {
          return {
            id: it.id,
            name: `${it.firstName} ${it.lastName}`,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    closeDialog() {
      this.dialog = false;
      this.currentBonusId = undefined;
      this.$refs.form.resetValidation(); // Reset form validation
    },
  },
};
</script>

<style scoped>
.carrent-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.action-pill { display: inline-flex; align-items: center; gap: 6px; background: #2962FF; border: 1px solid #2962FF; color: #fff; padding: 8px 14px; border-radius: 10px; font-size: 12.5px; font-weight: 600; cursor: pointer; box-shadow: 0 4px 12px rgba(41,98,255,0.3); transition: transform 0.12s ease; font-family: inherit; }
.action-pill:hover { transform: translateY(-1px); }
.action-pill .v-icon { color: inherit !important; }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; flex-grow: 1; }

.carrent-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.carrent-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; }
.carrent-page >>> .v-text-field--outlined fieldset, .carrent-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.carrent-page >>> .v-text-field--outlined .v-input__slot, .carrent-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.carrent-page >>> .v-label { color: #6E7691 !important; }
.carrent-page >>> .v-text-field input, .carrent-page >>> .v-select__selection { color: #fff !important; }
.carrent-page >>> .v-text-field:not(.v-text-field--outlined) input { color: #fff !important; }
.carrent-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.carrent-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.carrent-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.carrent-page >>> .v-data-table tbody tr { background: #232838 !important; }
.carrent-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.carrent-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.carrent-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.carrent-page >>> .v-data-table tbody td .v-btn.warning { background: rgba(255,152,0,0.18) !important; color: #FFB74D !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.carrent-page >>> .v-data-table tbody td .v-btn.error { background: rgba(244,67,54,0.18) !important; color: #FF8A80 !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.carrent-page >>> .v-data-table tbody td .v-btn .v-icon { color: inherit !important; }
.carrent-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.carrent-page >>> .v-btn:not(.v-btn--icon):not(.action-pill) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.carrent-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.carrent-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.carrent-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.carrent-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
